import { SkyText } from "@skypointcloud/skypoint-ui";
import { BuildVersion } from "@/components/shell/BuildVersion";

/**
 * The footer that closes every page's content (SKILL "Footer present"; the template's
 * `.app-footer`: caption type, muted, divider above). Rendered once from `App.tsx`, at the end
 * of the scroll container, so it follows the page on a long screen and sits at the bottom of
 * the viewport on a short one. The company is spelled "Skypoint" (owner, 2026-09-27).
 *
 * The copyright sits left and the build stamp right (`BuildVersion`, owner 2026-09-28); on a
 * narrow screen the stamp wraps under the copyright.
 */
export function AppFooter() {
  return (
    <footer
      className="flex shrink-0 flex-wrap items-center justify-between gap-2 border-t border-border px-4 py-4"
      data-testid="app-footer"
    >
      <SkyText size={200} color="muted">
        © {new Date().getFullYear()} Skypoint Cloud Inc. All Rights Reserved
      </SkyText>
      <BuildVersion />
    </footer>
  );
}
